import CustomizedTable from "../components/PeerGroup/CustomizedTable";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { All, KeyValue, Query, SortDirection } from "../interfaces";

function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateUi: (
      uiField: string,
      uiValue: KeyValue[] | string[] | boolean | string | KeyValue,
    ) => {
      dispatch(actions.updateUi(uiField, uiValue));
      dispatch(actions.searchPush());
    },
    updateSort: (sortField: string, sortDirection: SortDirection) => {
      dispatch(actions.updateSortOrder(sortField, sortDirection));
    },
    resetState: (appState: Query) => {
      dispatch(actions.resetState(appState));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CustomizedTable);
